// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TagInput/style.css
 ** module id = 1217
 ** module chunks = 0
 **/